document.addEventListener('DOMContentLoaded', () => {
    const btnList = document.querySelectorAll('.button')
    if (btnList.length) {
        btnList.forEach((btn) => {
            btn.addEventListener('mouseenter', () => {
                btn.classList.add('button--enter')
            })
            btn.addEventListener('mouseleave', () => {
                btn.classList.remove('button--enter')
                btn.classList.add('button--leave')
                setTimeout(() => {
                    btn.classList.remove('button--leave')
                }, 400);
            })
        })
    }
})